module.exports = __webpack_public_path__ + "img/bunny-pbr2.jpg.280ab90f.webp";